"use strict";
// Reusable Stevie Images for tiles
Object.defineProperty(exports, "__esModule", { value: true });
exports.spritesUiGame = void 0;
var imageRecycler_sidecar_1 = require("@dive/to-engine/imageRecycler-sidecar");
var crokinoleLayers_sidecar_1 = require("../scene/crokinoleLayers-sidecar");
exports.spritesUiGame = imageRecycler_sidecar_1.imageRecycler.create('crokinole-ui', function () { return crokinoleLayers_sidecar_1.crokinoleLayers.getLayers().uiGame; });
